import { Model } from '@vuex-orm/core'
import Schools from 'src/api/schools.js'
import Classbooks from 'src/api/classbooks.js'
import BroadcastingServiceProvider from 'src/config/services/broadcasting/BroadcastingServiceProvider.ts'
import { BROADCASTING_PROVIDER } from 'src/config/constants.ts'

export class School extends Model {
  static entity = 'schools'

  static fields () {
    return {
      id: this.attr(null),
      name: this.string(''),
      street: this.string(''),
      slink: this.string(''),
      type: this.attr(null),
      uuid: this.string(''),
      timetable: this.attr(null),
      is_locked: this.boolean(false),
      is_beta: this.boolean(false),
      is_partner: this.boolean(false),
      user_count: this.number(0),
      teacher_count: this.number(0),
      contact_person: this.string(''),
      contact_phone: this.string(''),
      contact_email: this.string(''),
      contact_role: this.string(''),
      auth_driver: this.attr(null),
      app_branding: this.attr(null),
      can: this.attr({}),
      meta: this.attr({}),
      state: this.attr(''),
      color: this.string(''),
      locale: this.string('de'),
      installed_at: this.attr(null),
      properties: this.attr({})
    }
  }

  static isAuthMethod (method) {
    const me = this.store().getters['users/me']
    if (!me?.school?.auth_driver) return false
    return me.school.auth_driver.method === method
  }

  getCurrentActiveClassbook () {
    return this.getCurrentActiveSchoolYear()?.classbook
  }

  getCurrentActiveClassbookId () {
    return this.getCurrentActiveClassbook()?.id
  }

  getCurrentActiveSchoolYear () {
    return this.timetable.schoolyears.find(el => el.id === this.timetable.active_schoolyear_id)
  }

  getPreviousSchoolYear () {
    const previousSchoolYears = this.timetable.schoolyears
      .filter(el => el.id !== this.timetable.active_schoolyear_id && el.begins_at < this.getCurrentActiveSchoolYear().begins_at)
      .sort((a, b) => a.begins_at < b.begins_at ? 1 : -1)
    return previousSchoolYears[0]
  }

  getSchoolYearByKey (key) {
    return this.timetable.schoolyears.find(el => el.key === key)
  }

  getSchoolYearByClassbokId (classbookId) {
    if (!classbookId) return
    return this.timetable.schoolyears.find(el => el.classbook?.id === Number(classbookId))
  }

  static isNoSchool (school) {
    const keys = ['KINDERGARDEN', 'COMPANY']
    if (!school || Object.entries(school).length === 0) return false
    const { level } = school?.type
    return keys.includes(level)
  }

  static async fetchClassbook (classbookId) {
    if (!classbookId) return
    // use already fetched classbook if available
    const me = this.store().getters['users/me']
    if (me && Number(classbookId) === Number(me.school.getCurrentActiveClassbookId())) return me.school.getCurrentActiveClassbook()

    const { data } = await Classbooks.getClassbooks(classbookId)
    return data
  }

  get uri () {
    return Schools.schoolsUrl(this.uuid)
  }

  /**
   * Returns the appropriate broadcasting service instance based on school configuration.
   * @returns {import('@/types/services/broadcasting/BroadcastingService.ts').BroadcastingService}
   * TODO: look for the feature flag 'broadcast.echo.enabled' to ensure that the correct broadcasting provider is used whenever Centrifugo returns
   */
  get broadcastingService () {
    return BroadcastingServiceProvider.getService(BROADCASTING_PROVIDER.ECHO)
  }

  static mutators () {
    return {
      properties (prop) {
        return prop && Object.keys(prop)
          .reduce((acc, key) => {
            const value = ['menu_type'].includes(key) ? prop[key] : !!Number(prop[key])
            return ({ ...acc, [key]: value })
          }, {})
      }
    }
  }
}
